import { useFilterCompanies } from "@/providers/contexts";
import { Autocomplete } from "@/components/atoms";
import { AutocompleteOption } from "@/components/atoms/Autocomplete";
import { useCompanyFilterOptions } from "@/hooks";

// Only available to premium users
export const FundingTypeFilter = () => {
  const { fundingTypes } = useCompanyFilterOptions();

  const { filters: companyFilters, dispatch, loading } = useFilterCompanies();

  const { selectedFundingTypes } = companyFilters;

  const options: AutocompleteOption[] = fundingTypes.map(fundingType => ({
    key: fundingType.id,
    value: fundingType.funding_type_name,
  }));

  const selectedOptions = selectedFundingTypes.map(selected => {
    const type = options.find(option => option.key === selected.id);

    return {
      key: type?.key ?? "",
      value: type?.value ?? "",
    };
  });

  return (
    <Autocomplete
      componentName="funding-type"
      inputLabel="Funding Type"
      options={options}
      value={selectedOptions}
      multiple
      onChange={(_, value) => {
        const selectedValues = (value as AutocompleteOption[]).filter(Boolean);

        const selected = fundingTypes.filter(type =>
          selectedValues.some(el => el.key === type.id),
        );

        dispatch({
          type: "SET_FILTERS",
          payload: { selectedFundingTypes: selected },
        });
      }}
      loading={loading}
    />
  );
};
